import { BaseModel } from './base-model';
import { RouteGeometry } from './voyage-routing-model';
import { CrossedGeometry } from '../utils/geometries-intersection';

export interface Properties {
    id: string;
    name: string;
    coordinator: string;
}

export interface NavAreasFeature extends CrossedGeometry {
    type: string;
    properties: Properties;
}

export interface NavAreas {
    type: string;
    features: NavAreasFeature[];
}

export abstract class VesselNavAreasModelBase extends BaseModel {
    abstract get areas(): NavAreasFeature[] | null;
    abstract getCrossedNavAreas(route: RouteGeometry) : string;
}

let VesselNavAreasModel: VesselNavAreasModelBase|null = null;

function setVesselNavAreasModel(model: VesselNavAreasModelBase) {
    VesselNavAreasModel = model;
}

export { VesselNavAreasModel, setVesselNavAreasModel };
